import React from "react";
import Linkify from "linkify-react";

// Autolink URLs inside chat messages. Emojis are plain Unicode and render
// natively inside the span. Color is inherited so links stay readable on both
// the teal "mine" bubble (white text) and the grey "other" bubble.
const CHAT_LINKIFY_OPTS = {
  defaultProtocol: "https",
  target: "_blank",
  rel: "noopener noreferrer nofollow",
  className: "underline underline-offset-2 break-all",
  validate: { email: false },
  attributes: { "data-testid": "chat-link" },
};

export function ChatMessageText({ body }) {
  return (
    <span className="whitespace-pre-wrap break-words">
      <Linkify options={CHAT_LINKIFY_OPTS}>{body || ""}</Linkify>
    </span>
  );
}
